module.exports = __webpack_public_path__ + "static/media/Image Corrupted.7c7bbf05.svg";